import {initSelects} from './select';
import product from "./product";

export default () => {
	const cart = document.querySelector('.js-cart');
	const sidemenu = document.querySelector('.js-sidemenu');

	const addToCartBtn = document.querySelector('.prd-DetailForm_Button');

	if (addToCartBtn) {
		addToCartBtn.addEventListener('click', (e) => {
			e.preventDefault();
		});
	}

	if (cart) {
		if (window.location.href.includes('#cart')) {
			removeHash();
			openCart();
		}
	}

	function closeCart() {
		if (cart) {
			sidemenu.classList.remove('sidemenu--opened');
			// sidemenu.classList.remove('sidemenu__mini-bag');
			document.body.classList.remove('is-sidemenu-opened');
		}
	}

	window.oc = openCart;

	function openCart() {
		if (cart) {
			sidemenu.classList.add('sidemenu--opened');
			// sidemenu.classList.add('sidemenu__mini-bag')
			document.body.classList.add('is-sidemenu-opened');

			const tabs = document.querySelectorAll('.js-sidemenu-tab');

			tabs.forEach(tab => {
				tab.classList.remove('sidemenu__tab--active');
			});

			const activeTab = document.querySelector(`.js-sidemenu-tab[data-tab="mini-bag"]`);
			activeTab.classList.add('sidemenu__tab--active');

			const asideButtons = document.querySelectorAll('.sidemenu-buttons__button');
			asideButtons.forEach(function(button) {
				if (button.dataset.target == 'mini-bag') {
					button.classList.add('sidemenu-buttons__button--active');
				}
				else {
					button.classList.remove('sidemenu-buttons__button--active');
				}
			});

		}
	}

	// watch select
	const sizeSelectEls = document.querySelectorAll('.buy__select .select, .sticky-add .js-size-select');
	sizeSelectEls.forEach(select => {
		select.addEventListener('update', (e) => {
			let status = '';
			const option = e.detail;
			const id = +option.dataset.id;
			const size = option.dataset.value;

			if (option.classList.contains('select__list-item--few')) {
				status = 'few';
			}
			if (option.classList.contains('select__list-item--oos')) {
				status = 'oos';
			}

			updateSelects(option, 'SIZE: ');

			if (size) {
				updateSizeLabels(size, 'SIZE: ');
			}

			if (id) {
				updateVariant(id, status);
				window.history.replaceState('', '', updateURLParameter(window.location.href, 'variant', id));
			}
		});

	});

	function globalEventDelegation(e) {
		if (e.target.closest('.prd-QuickBuy_Button.is-oos')) {
			const bisModal = document.querySelector('.js-bis');

			if (!bisModal) {
				return;
			}

			bisModal.dataset.variantId = e.target.dataset.id;

			backInStock(true);
			return;
		}

		if (e.target.closest('.mini-bag__visibility-toggle')) {
			const recommendationsCarousel = document.querySelector('.psh-Recommendations_Inner');
			const recommendationsCarouselBody = document.querySelector('.psh-Recommendations_List');
			const currentState = recommendationsCarousel.getAttribute('aria-expanded') === 'true';

			recommendationsCarousel.style.setProperty('--Max_Height', `${recommendationsCarouselBody.offsetHeight}px`);
			recommendationsCarousel.setAttribute('aria-expanded', !currentState);
		}

		if (e.target.closest('.js-add-to-bag')) {
			const btn = e.target.closest('.js-add-to-bag');
			const bisModal = document.querySelector('.js-bis');
			let id = +btn.dataset.id;
			let q = +btn.dataset.q;
			let quantity = q || 1;

			const miniBagItem = btn.closest('.product-card, .js-cart-item');
			if (miniBagItem) {
				miniBagItem.classList.remove('.product-card--removed');
			}

			if (btn.classList.contains('is-disabled')) {
				const group = btn.closest('.js-buy-group');
				const buySelect = group.querySelector('.js-size-select');

				if (buySelect && !buySelect.classList.contains('select--opened')) {
					setTimeout(() => {
						const holder = buySelect.querySelector('.select__holder');
						if (holder) {
							holder.click();
						}
					}, 20);
				}

				return;
			}

			if (btn.classList.contains('is-oos') && bisModal) {
				bisModal.dataset.variantId = e.target.dataset.id;

				backInStock(true);
				return;
			}

			// set state 'adding' for sticky add
			let sticky = btn.closest('.sticky-add');
			if (sticky && !btn.classList.contains('is-disabled') && !btn.classList.contains('is-oos')) {
				sticky.classList.add('is-sticky-adding');

				setTimeout(function() {
					sticky.classList.remove('is-sticky-adding');
				}, 1000);
			}

			if (id && quantity) {
				const items = [];
				const item = {
					id: id,
					quantity: quantity
				};

				const btnOverlay = btn.querySelector('.btn-overlay');
				if (btnOverlay) {
					btnOverlay.classList.add('btn-overlay--active');

					setTimeout(() => {
						btnOverlay.classList.remove('btn-overlay--active');
					}, 1000);
				}

				items.push(item);
				loading(true);
				addToCart(items);
			}
		}

		if (e.target.closest('.js-add-to-bag-delayed')) {
			const btn = e.target.closest('.js-add-to-bag-delayed');
			const card = btn.closest('.js-card');
			const btnCancel = card.querySelector('.js-add-to-bag-cancel');

			let id = +btn.dataset.id;
			let quantity = 1;

			if (id) {
				const items = [];
				const item = {
					id: id,
					quantity: quantity
				};

				card.classList.add('product-card--wl-added');

				let timeout = setTimeout(() => {
					// card.classList.remove('product-card--wl-added');
					card.style.display = 'none';

					if (removeBtn) {
						removeBtn.click();
					}
					items.push(item);
					loading(true);
					addToCart(items, true, true);
				}, 5000);

				if (btnCancel) {
					btnCancel.addEventListener('click', function(e) {
						e.preventDefault();
						clearTimeout(timeout);
						card.classList.remove('product-card--wl-added');
					});
				}

			}
		}

		if (e.target.classList.contains('js-open-cart')) {
			e.preventDefault();
			openCart();
		}

		if (e.target.closest('.js-add-card') && !e.target.closest('.js-add-card').classList.contains('is-selecting-size')) {
			e.preventDefault();
			const btn = e.target.closest('.js-add-card');
			const card = btn.closest('.card');

			if (card) {
				let btnExpand = document.querySelector('.js-sizes-expand');

				if (btnExpand && !btn.classList.contains('click-fix')) {
					btnExpand.click();
				}
			}

			let id = +btn.dataset.id;
			let quantity = 1;
			const items = [{
				id: id,
				quantity: quantity
			}];

			loading(true);
			addToCart(items, true);
		}

		if (e.target.closest('.js-cart-select-item')) {
			const btn = e.target;
			const miniBagItem = btn.closest('.product-card, .js-cart-item');

			let line = +miniBagItem.dataset.index;
			let id = +miniBagItem.dataset.id;
			let q = +btn.innerText;

			let quantity = q || 1;

			if (id && quantity) {
				const items = [];
				const item = {
					id: id,
					quantity: quantity
				};
				items.push(item);

				loading(true);
				changeCart(line, quantity);
			}
		}

		if (e.target.closest('.js-cart-select-size')) {
			const productCardEl = e.target.closest('.js-cart-item');
			const selectedValue = e.target.closest('.js-cart-select-size').dataset.value;
			const selectEl = productCardEl.querySelector('.js-product-card__size-select');

			selectEl.value = selectedValue;
			selectEl.dispatchEvent(new Event('change'));
		}

		// open notify popup from sticky add in one step
		if (e.target.closest('.select__list-item--oos')) {

			const btn = e.target.closest('.select__list-item--oos');
			const sticky = btn.closest('.sticky-add');

			if (sticky) {
				const bisModal = document.querySelector('.js-bis');

				if (!bisModal) {
					return;
				}

				bisModal.dataset.variantId = e.target.dataset.id;

				backInStock(true);
			}
		}

		if (e.target.closest('.js-add-to-bag-rec-card')) {
			const btn = e.target.closest('.js-add-to-bag-rec-card');
			const id = +btn.dataset.id;
			const quantity = 1;

			if (id && quantity) {
				const items = [];
				const item = {
					id: id,
					quantity: quantity
				};
				e.preventDefault();
				items.push(item);
				loading(true);
				addToCart(items, true);
				openCart();
			}
		}

		if (e.target.closest('.js-add-to-bag-form')) {
			const form = e.target.closest('.prd-QuickBuy_Form');
			const id = +form.querySelector('[name="id"]').value;
			const quantity = 1;

			if (id && quantity) {
				const items = [];
				const item = {
					id: id,
					quantity: quantity
				};
				e.preventDefault();
				items.push(item);
				loading(true);
				addToCart(items, true);
				openCart();
			}
		}

		if (e.target.closest('.js-line-remove')) {
			let item = e.target.closest('.js-cart-item');
			// let line = +item.dataset.index;
			let id = item.dataset.key;

			// removeFromCart(line, item, true);
			removeFromCart(id, item, true);
		}

		if (e.target.closest('.js-line-remove-now')) {
			let item = e.target.closest('.js-cart-item');
			let id = item.dataset.key;
			removeFromCart(id, item, false);
		}

	}

	// Prevent duplicated events
	// document.removeEventListener('click', globalEventDelegation); has no effect for some reason.
	if (!window.cartJsLoaded) {
		document.addEventListener('click', globalEventDelegation);
	}

	window.cartJsLoaded = true;

	document.addEventListener('cartDrawer:refreshed', () => {
		const section = document.querySelector('.mini-bag');
		initSelects();

		const LOADING_CLASS = 'is-loading';

		section.classList.remove(LOADING_CLASS);
	});

	async function addToCart(items_arr, silent = false, mutePopup = false) {
		let data = {
			items: items_arr
		};

		let response = await fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json;charset=utf-8'
			},
			body: JSON.stringify(data)
		});

		if (response.status === 200) {
			if (!silent) {
				setAddPopupState(true);
			}
			else {
				if (mutePopup !== true) {
					openCart();
				}
			}

			renderCart();
			loading(false);
		}
		else if (response.status === 422) {
			console.log('out of stock');
			loading(false);
		}
		else {
			console.log('product add error');
			loading(false);
		}
	}

	async function removeFromCart(id, item, silent = false) {
		if (silent) {
			item.classList.add('product-card--removed');
			item.classList.add('product-card--faded');
			setTimeout(() => {
				item.classList.add('product-card--deleted');
				renderCart();
			}, 3300);
			// removeSilent(item);

			let counterVal = +document.querySelector('.js-counter').innerText;
			let newCounterVal = counterVal - (+item.dataset.q);
			updateCounters(newCounterVal);
		}
		else {
			loading(true);
		}

		let data = {
			'id': id,
			'quantity': 0
		};

		let response = await fetch('/cart/change.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json;charset=utf-8'
			},
			body: JSON.stringify(data)
		});
		if (response.status === 200) {
			if (silent == false) {
				renderCart();
				loading(false);
			}
			else {

			}
		}
	}

	async function changeCart(line, q, silent = false) {
		loading(true);
		let data = {
			'line': line,
			'quantity': q
		};

		let response = await fetch('/cart/change.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json;charset=utf-8'
			},
			body: JSON.stringify(data)
		});

		if (response.status === 200) {
			renderCart();
			loading(false);
		}
		else if (response.status === 422) {
			console.log('out of stock');
			loading(false);
		}
		else {
			console.log('product add error');
			loading(false);
		}
	}

	function loading(isLoading) {
		const wrappers = document.querySelectorAll('.js-cart');
		const LOADING_CLASS = 'is-loading';

		wrappers.forEach(function(wrapper) {
			if (isLoading) {
				wrapper.classList.add(LOADING_CLASS);
			}
			else {
				wrapper.classList.remove(LOADING_CLASS);
			}
		});
	}

	function renderCart() {
		// const base = window.location.href.split('?')[0];
		const base = Shopify.routes.root;
		const cartUrl = 'cart?view=alt';
		const url = `${base}${cartUrl}`;
		const cartAddEvent = new CustomEvent('cart:added');
		fetch(url).then(function(response) {
			return response.text();
		}).then(function(html) {
			document.dispatchEvent(cartAddEvent);

			const element = document.createElement('div');
			element.innerHTML = html;
			const newCart = element.querySelector('.js-cart');

			const cartWrapper = document.querySelector('.js-cart');
			cartWrapper.innerHTML = newCart.innerHTML;

			const counterVal = +newCart.dataset.total;

			updateCounters(counterVal);
			updateMainCart();

			initSelects();

		}).catch(function(err) {
			console.warn('Something went wrong.', err);
		});
	}

	document.addEventListener('cartDrawer:refreshed', () => {
		renderCart();
		openCart();
	});

	function updateCounters(value) {
		const counters = document.querySelectorAll('.js-counter');
		const HIDDEN_CLASS = 'is-hidden';

		counters.forEach(function(counter) {
			if (value > 0) {
				counter.innerText = value;
				counter.classList.remove(HIDDEN_CLASS);
			}
			else {
				counter.classList.add(HIDDEN_CLASS);
				counter.innerText = 0;
			}
		});
	}

	function updateSizeLabels(sizename) {
		const sizeLabels = document.querySelectorAll('.js-size-label');
		sizeLabels.forEach(function(label) {
			label.innerText = sizename;
		});
	}

	function updateSelects(option, prefix = '') {
		let selectEls = document.querySelectorAll('.js-size-select');
		let status = '';
		const sizename = option.dataset.value;

		if (option.classList.contains('select__list-item--few')) {
			status = 'few';
		}
		if (option.classList.contains('select__list-item--oos')) {
			status = 'oos';
		}

		const selectLabels = document.querySelectorAll('.js-buy-group .js-size-name');
		selectLabels.forEach(function(label) {
			label.innerText = prefix + sizename;
		});
	}

	function updateVariant(id, status = '') {
		const buttons = document.querySelectorAll('.buy__btn, .sticky-add .js-add-to-bag');
		const selectEls = document.querySelectorAll('.js-size-select');

		buttons.forEach(function(button) {
			button.dataset.id = id;
			setStatusClass(button, status);
		});

		selectEls.forEach(function(select) {
			setStatusClass(select, status);
		});
	}

	function setAddPopupState(state) {
		const popup = document.querySelector('.js-cart-add');
		const body = document.body;
		if (!popup) return;

		const ADD_VISIBLE_CLASS = 'cart-add--visible';

		if (state) {
			popup.classList.add(ADD_VISIBLE_CLASS);
			body.classList.add('is-cart-add-visible');
			setTimeout(() => {
				popup.classList.remove(ADD_VISIBLE_CLASS);
				body.classList.remove('is-cart-add-visible');
			}, 3000);
		}
		else {
			popup.classList.remove(ADD_VISIBLE_CLASS);
			body.classList.remove('is-cart-add-visible');
		}
	}

	function formatPrice(symbol, price) {
		price = price / 100;
		const formattedNumber = symbol + price.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
		return formattedNumber;
	};

	function removeHash() {
		history.pushState('', document.title, window.location.pathname + window.location.search);
	}

	function setStatusClass(el, status, prefix = 'is-') {
		el.className = el.className.replace(/\bis-\S+/g, '');
		if (status) {
			el.classList.add(prefix + status);
		}
	}

	function updateMainCart() {
		let section = document.querySelector('section.cart');
		const LOADING_CLASS = 'is-loading';

		if (!section) return;
		section.classList.add(LOADING_CLASS);

		const base = Shopify.routes.root;
		const sectionId = '' + section.id.replace('shopify-section-', '');
		let url = `${base}?section_id=${sectionId}`;

		fetch(url).then(function(response) {
			return response.text();
		}).then(function(html) {
			let element = document.createElement('div');
			element.innerHTML = html;

			let grid = section.querySelector('.js-cart-inner');
			let newGrid = element.querySelector('.js-cart-inner');
			if (grid && newGrid) {
				grid.innerHTML = newGrid.innerHTML;
			}

			initSelects();

			section.classList.remove(LOADING_CLASS);

		}).catch(function(err) {
			console.warn('Something went wrong.', err);
		});

	}

	function updateURLParameter(url, param, paramVal) {
		let newAdditionalURL = '';
		let tempArray = url.split('?');
		let baseURL = tempArray[0];
		let additionalURL = tempArray[1];
		let temp = '';
		if (additionalURL) {
			tempArray = additionalURL.split('&');
			for (let i = 0; i < tempArray.length; i++) {
				if (tempArray[i].split('=')[0] != param) {
					newAdditionalURL += temp + tempArray[i];
					temp = '&';
				}
			}
		}

		let rows_txt = temp + '' + param + '=' + paramVal;
		return baseURL + '?' + newAdditionalURL + rows_txt;
	}

	function backInStock(state) {
		const popup = document.querySelector('.js-bis');
		if (!popup) return;

		const closeEls = document.querySelectorAll('.js-close-bis');

		if (state) {
			popup.classList.add('bis--visible');
			document.body.classList.add('is-bis-visible');
		}
		else {
			popup.classList.remove('bis--visible', 'bis--success');
			document.body.classList.remove('is-bis-visible');
		}

		closeEls.forEach(function(el) {
			el.addEventListener('click', function(e) {
				e.preventDefault();
				popup.classList.remove('bis--visible', 'bis--success');
				document.body.classList.remove('is-bis-visible');
			});
		});
	}

	async function handleKlaviyo() {
		const popup = document.querySelector('.js-bis');
		if (!popup) return;

		const form = document.querySelector('.js-bis-form');
		const btnCheckbox = document.querySelector('.js-toggle-checkbox');
		const checkbox = document.querySelector('.js-bis-checkbox');

		btnCheckbox.addEventListener('click', function(e) {
			e.preventDefault();
			checkbox.click();
		});

		form.addEventListener('submit', async function(e) {
			e.preventDefault();

			const email = form.querySelector('input[type="email"]').value;
			const variantId = popup?.dataset.variantId;

			const request = await subscibeToBIS(email, variantId);

			if (checkbox.checked) {
				await subscribeToNewsletter(email);
			}

			if (request.ok) {
				popup.classList.add('bis--success');
			}
			else {
				console.log('BIS error');
			}
		});
	}

	async function subscibeToBIS(email, variantId) {
		const payload = {
			data: {
				type: 'back-in-stock-subscription',
				attributes: {
					channels: ['EMAIL'],
					profile: {
						data: {
							type: 'profile',
							attributes: {
								email,
							},
						},
					},
				},
				relationships: {
					variant: {
						data: {
							type: 'catalog-variant',
							id: `$shopify:::$default:::${variantId}`,
						},
					},
				},
			},
		};

		const options = {
			method: 'POST',
			headers: {
				revision: '2023-12-15',
				'content-type': 'application/json',
			},
			body: JSON.stringify(payload),
		};

		return await fetch(
			`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${window.theme.klaviyo.apiKey}`,
			options,
		);
	}

	async function subscribeToNewsletter(email) {
		const payload = {
			data: {
				type: 'subscription',
				attributes: {
					profile: {
						data: {
							type: 'profile',
							attributes: {
								email,
							},
						},
					},
				},
				relationships: {
					list: {
						data: {
							type: 'list',
							id: window.theme.klaviyo.mailingListId,
						},
					},
				},
			},
		};

		const options = {
			method: 'POST',
			headers: {
				revision: '2023-12-15',
				'content-type': 'application/json',
			},
			body: JSON.stringify(payload),
		};

		return await fetch(
			`https://a.klaviyo.com/client/subscriptions/?company_id=${window.theme.klaviyo.apiKey}`,
			options,
		);
	}

	handleKlaviyo();
};
